import { render, staticRenderFns } from "./GalleryComponent.vue?vue&type=template&id=407fa44a&scoped=true&"
import script from "./GalleryComponent.vue?vue&type=script&lang=js&"
export * from "./GalleryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407fa44a",
  null
  
)

export default component.exports